<template>
  <span>
    <!-- Capa 1: Áreas de estudio -->
    <!---->
    <DaiCapaGeojson
      id="areas_region_nororiental"
      :url="publicPath+'data/capasv2/01_01_region_nororiental.geojson'"
      titulo="Región Nororiental"
      :visible.sync="region_nororiental_visible"
      :estilo-capa="{
        stroke: { width: 2, color: '#847819', lineDash: [3, 3] },
        fill: { color: '#fff0' },
      }"
      :z-index="7"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="areas_subcuenca"
      :url="publicPath+'data/capasv2/01_02_subcuenca_texcoco.geojson'"
      titulo="Subcuenca de Texcoco"
      :visible.sync="subcuenca_visible"
      :estilo-capa="{
        stroke: { width: 2, color: '#000000', lineDash: [3, 3] },
        fill: { color: '#fff0' },
      }"
      :z-index="8"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="areas_zona_pelt"
      :url="publicPath+'data/capasv2/01_05_zona_influencia_pelt.geojson'"
      titulo="Zona de influencia del PELT"
      :visible.sync="zona_pelt"
      :estilo-capa="{
        stroke: { width: 2, color: '#A70000' ,lineDash: [1, 4] },
        fill: { color: '#fff0' },
      }"
      :z-index="9"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="areas_zona_federal_lago_texcoco"
      :url="publicPath+'data/capasv2/01_03_zona_federal_lago_texcoco.geojson'"
      titulo="Zona Federal del Lago de Texcoco"
      :visible.sync="zona_federal_lago_texcoco_visible"
      :estilo-capa="{
        stroke: { width: 2, color: '#660031' },
        fill: { color: '#fff0' },        
      }"
      :z-index="10"
    />
    <DaiCapaGeojson
      id="areas_obra_principal_naim"
      :url="publicPath+'data/capasv2/01_04_obra_principal_naim.geojson'"
      titulo="Obra principal exNAICM-Terminal"
      :visible.sync="areas_obra_principal_naim_visible"
      :estilo-capa="{
        stroke: { width: 2, color: '#000000' },
        fill: { color: '#4B4453'+'80' }, // el 80 es la opacidad a 50%
      }"
      :z-index="11"
      :use-loader="true"
    />

    
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  data(){
    return {
      publicPath: process.env.BASE_URL,
    }
  },
  computed: {
    ...mapState("mapa", ["temasExpandidos"]),
    esteTemaActivo() {
      return this.temasExpandidos.areas;
    },
    region_nororiental_visible: {
      get() {
        return this.estaCapaActiva("areas_region_nororiental");
      },
      set(visible) {
        this.enciendeApagaCapa(visible, "areas_region_nororiental");
      },
    },
    subcuenca_visible: {
      get() {
        return this.estaCapaActiva("areas_subcuenca");
      },
      set(visible) {
        this.enciendeApagaCapa(visible, "areas_subcuenca");
      },
    },
    zona_federal_lago_texcoco_visible: {
      get() {
        return this.estaCapaActiva("areas_zona_federal_lago_texcoco");
      },
      set(visible) {
        this.enciendeApagaCapa(visible, "areas_zona_federal_lago_texcoco");
      },
    },
    areas_obra_principal_naim_visible: {
      get() {
        return this.estaCapaActiva("areas_obra_principal_naim");
      },
      set(visible) {
        this.enciendeApagaCapa(visible, "areas_obra_principal_naim");
      },
    },
    zona_pelt: {
      get() {
        return this.estaCapaActiva("areas_zona_pelt");
      },
      set(visible) {
        this.enciendeApagaCapa(visible, "areas_zona_pelt");
      },
    }
  },
  watch: {
    esteTemaActivo(nv) {
      this.region_nororiental_visible = nv;
      this.subcuenca_visible = nv;
      this.zona_federal_lago_texcoco_visible = nv;
      this.areas_obra_principal_naim_visible = nv;
      this.zona_pelt = nv
    },
  },
  mounted(){
    let nv = this.esteTemaActivo;
    this.region_nororiental_visible = nv;
    this.subcuenca_visible = nv;
    this.zona_federal_lago_texcoco_visible = nv;
    this.areas_obra_principal_naim_visible = nv;
    this.zona_pelt = nv
  },
  methods: {
    estaCapaActiva(capa) {
      return this.$store.getters["mapa/estaCapaActiva"](capa);
    },
    enciendeApagaCapa(enciendeApaga, capa) {
      this.$store.commit(
        `mapa/${enciendeApaga ? "enciendeCapa" : "apagaCapa"}`,
        capa
      );
    },
  },
};
</script>